import * as types from './actionTypes';
import * as API_END_POINTS from '../constants/api.js';
import axios from 'axios';
// import { updateQueryStringParameter } from '../helpers/index';
// import { each } from 'lodash';

export function getDriverEmergencyInfo(position) {
  return dispatch => {
    /* dispatch({
      type: types.GET_DRIVEREMERGENCY_INFO,
      driveremergencyinfo: emergencyInfo
    });*/
    let localDetails = JSON.parse(localStorage.getItem('businessAuthData'));
    let extendURL = localDetails.id +
      '/jobslist?lat=' +
      position.coords.latitude +
      '&lng=' +
      position.coords.longitude +
      '&limit=10&offset=0';

    axios
      .get(API_END_POINTS.GET_DRIVER_JOB_QUEUE + extendURL, {
        headers: {
          //'garage-id': garage_id,
          Accept: 'application/json,',
          'Content-Type': 'application/json'
        }
        //withCredentials:true
      })
      .then(response => {
        if (response.status === 200) {
          dispatch({
            type: types.GET_DRIVEREMERGENCY_INFO,
            driveremergencyinfo: response.data
          });
        }
      })
      .catch(err => {
        dispatch({
          type: types.SHOW_TOAST_MESSAGE,
          toastMessage: err.response && err.response.data && err.response.data.message
            ? err.response.data.message
            : 'Unknown error occurred please try again',
          toastType: 'error'
        });
      });
  };
}

export function driverAcceptJob(flagType, clientId) {
  return dispatch => {
    dispatch({
      type: types.DRIVER_ACCEPT_FLAG,
      driverAcceptFlag: flagType,
      clientId: clientId
    });
  };
}

export function driverOfflineWarningShow(acceptFlag) {
  return dispatch => {
    if (acceptFlag) {
      dispatch({
        type: types.DRIVER_OFFLINE_FLAG,
        driverOfflineFlag: true
      });
    }
  };
}

export function driverSetPositions(positionInfo) {
  return dispatch => {
    dispatch({
      type: types.DRIVER_POSITION,
      dpositioninfo: positionInfo
    });
  };
}

export function navigationFlagSet(typeData) {
  return dispatch => {
    dispatch({
      type: types.NAVIGATION_FLAG,
      navigationflag: typeData
    });
  };
}

export function driverOfflineWarningHide() {
  return dispatch => {
    dispatch({
      type: types.DRIVER_OFFLINE_FLAG,
      driverOfflineFlag: false
    });
  };
}

export function driverStatusUpdateFlag(flagType) {
  return dispatch => {
    dispatch({
      type: types.DRIVER_STATUS_UPDATE_FLAG,
      driverstatusupdate: flagType
    });
  };
}

// Driver offline and online mode changes API
export function driverOnlineOfflineMode(status, router) {
  //let garage_id = JSON.parse(localStorage.getItem('garage_id'));
  return dispatch => {
    // axios.defaults.headers.common['x-access-token'] = localStorage.getItem('businessAccessToken');
    dispatch(showloader());
    axios
      .put(API_END_POINTS.DRIVER_ONLINE_OFFLINE_MODE + status, {
        headers: {
          //'garage-id': garage_id,
          Accept: 'application/json,',
          'Content-Type': 'application/json'
        }
        //withCredentials:true
      })
      .then(response => {
        if (response.status == 200) {
          dispatch(driverStatusUpdateFlag(true));
          const authData = localStorage.getItem('businessAuthData')
            ? JSON.parse(localStorage.getItem('businessAuthData'))
            : {};
          authData.driverStatus = response.data.status_type_id;
          localStorage.setItem('businessAuthData', JSON.stringify(authData));
          if (status != 2) {
            router.push('/driver-dashboard');
          }
        }
        dispatch(hideloader());
      })
      .catch(err => {
        dispatch(hideloader());
        dispatch({
          type: types.SHOW_TOAST_MESSAGE,
          toastMessage: err.response && err.response.data && err.response.data.message
            ? err.response.data.message
            : 'Unknown error occurred please try again',
          toastType: 'error'
        });
      });
  };
}

export function jobRequestStatusChange(statusType, statusData, router, routeTo, clientId) {
  let garage_id = JSON.parse(localStorage.getItem('garage_id'));
  return dispatch => {
    // const postMethod = (methodType == 'get') ? axios.get : axios.post;
    axios
      .post(API_END_POINTS.JOB_STATUS_CHANGE + statusType, statusData, {
        headers: {
          'garage-id': garage_id,
          Accept: 'application/json,',
          'Content-Type': 'application/json'
        }
        //withCredentials:true
      })
      .then(response => {
        if (response.status === 200) {
          dispatch(driverStatusUpdateFlag(true));
          if (statusType == 'driveracceptjob') {
            dispatch({
              type: types.DRIVER_ACCEPT_FLAG,
              driverAcceptFlag: true,
              driverAcceptClick: true,
              clientId: clientId
            });
            dispatch({
              type: types.SHOW_TOAST_MESSAGE,
              toastMessage: 'Accepted Job Succesfully',
              toastType: 'success'
            });
          } else {
            router.push(routeTo);
          }

          if (statusData.status == 12) {
            dispatch({
              type: types.DRIVER_ACCEPT_FLAG,
              driverAcceptFlag: false,
              clientId: ''
            });
            dispatch({
              type: types.SHOW_TOAST_MESSAGE,
              toastMessage: 'Job Ended succesfully',
              toastType: 'success'
            });
          }

          if (statusType == 'driverdeclinejob') {
            dispatch({
              type: types.SHOW_TOAST_MESSAGE,
              toastMessage: 'Job Declined succesfully',
              toastType: 'success'
            });
          }
        }
      })
      .catch(err => {
        dispatch({
          type: types.SHOW_TOAST_MESSAGE,
          toastMessage: err.response && err.response.data && err.response.data.message
            ? err.response.data.message
            : 'Unknown error occurred please try again',
          toastType: 'error'
        });
      });
  };
}

export function showloader() {
  return dispatch => {
    //axios.defaults.headers.common['x-access-token'] = localStorage.getItem('businessAccessToken');
    dispatch({
      type: types.LOADER_DISPLAY,
      displayloader: true
    });
  };
}

export function hideloader() {
  return dispatch => {
    //axios.defaults.headers.common['x-access-token'] = localStorage.getItem('businessAccessToken');
    dispatch({
      type: types.LOADER_DISPLAY,
      displayloader: false
    });
  };
}



// WEBPACK FOOTER //
// ./src/actions/driverEmergencyActions.js